{
  "addAddress": "Añadir dirección",
  "addContactData": "Añadir datos de contacto",
  "additionalId": "Número de artículo",
  "additionalStockInfos": "Información adicional",
  "additionalTax": "más{0} de IVA",
  "addProducts": "Añadir productos",
  "addProductToCollection": "Agregar producto a una colección",
  "addProductToComparison": "Agregue el producto a la comparación del producto",
  "addProductToQuote": "Agregar producto a una consulta",
  "address": {
    "addition": "Línea de dirección adicional",
    "city": "Ciudad",
    "clientNumber": "Número de cliente",
    "companyName": "Nombre y forma jurídica",
    "country": "País",
    "defaultBillingAddress": "Dirección de facturación por defecto",
    "defaultDeliveryAddress": "Dirección de envío por defecto",
    "details": "Detalles",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "postBox": "Apartado de correos",
    "primaryAddress": "Dirección principal",
    "street": "Calle",
    "url": "URL",
    "website": "Página web",
    "zipCode": "Código postal",
    "zipCodeLong": "Código postal"
  },
  "addresses": "Direcciones",
  "addToCart": "Añadir a la cesta",
  "archiveAll": "Archivar todo",
  "availability": "Disponibilidad",
  "b2bCommerPowered": "Powered by ITscope B2B Commerce",
  "backToPlatform": "Volver a ITscope",
  "billingAddress": "Dirección de facturación",
  "cancel": "Cancelar",
  "cart": {
    "optimizationFailed": "La optimización de la cesta de la compra ha fallado",
    "optimizationUnavailable": "No se puede ejecutar la optimización de la cesta de la compra porque hay demasiados productos en la cesta",
    "removeAll": "Vaciar cesta",
    "removeAllError": "La cesta no se vació",
    "removeAllSuccess": "La cesta se ha vaciado correctamente"
  },
  "cartOutdated": {
    "description": "El pedido no se ha podido enviar porque el carrito de la compra ya no está actualizado. Por favor, vuelve a cargar el carrito y realiza el pedido de nuevo.",
    "title": "El carrito de la compra ya no está actualizado"
  },
  "cartPositionComment": "Comentarios",
  "categories": "Categorías",
  "changed": "Cambiado",
  "changePassword": "Cambiar contraseña",
  "charger": {
    "charger": "Cargador incluido",
    "chargerIncludedTooltip": "El cargador está incluido con este producto.",
    "chargerNotIncludedHint": "Los cargadores con las siguientes compatibilidades de carga pueden utilizarse con este producto.",
    "chargerNotIncludedTooltip": "El cargador no está incluido con este producto.",
    "noCharger": "Sin cargador incluido"
  },
  "checkEmail": "Comprobar correo electrónico",
  "checkoutExpiredDialog": {
    "buttonCaption": "Volver a la caja",
    "description": "Su pedido está esperando",
    "title": "¿Sigues ahí?"
  },
  "chooseAddress": "Elegir dirección",
  "clientNumber": "Número de cliente",
  "closeErrorOrders": "Cerrar columna con pedidos erróneos",
  "closeFilter": "Cierre el filtro",
  "closeMessage": "Cerrar mensaje",
  "closeQuoteActivity": "Cerrar actividades",
  "collapseAccessoryCategory": "Contraer categoría de accesorios «{0}»",
  "collapseDescription": "Contraer descripción «{0}»",
  "collection": {
    "addAttachment": "Añadir anexo",
    "addCollection": "Nueva colección",
    "addedToCartFailure": "No se ha podido añadir la colección a la cesta de la compra",
    "addedToCartPartialSuccess": "No se han podido añadir algunos artículos a la cesta de la compra",
    "addedToCartSuccess": "Colección añadida a la cesta",
    "addProductToExistingCollection": "Añadir producto a la colección existente:",
    "addProductToNewCollection": "o crear una nueva colección:",
    "addToCart": "Añadir a la cesta",
    "assignee": "Empleado responsable",
    "collections": "Colecciones",
    "collectProduct": "Recoger el producto",
    "data": "Fechas",
    "deleteAction": "Borrar colección",
    "deleteDialog": "¿Está seguro de que desea eliminar esta colección?",
    "deletedMessage": "Se retiró la colección",
    "duplicate": "Duplicar",
    "editTitle": "Cambiar título de la colección",
    "emailSent": "La colección se ha enviado correctamente por correo electrónico.",
    "emptyCollection": "No hay productos en esta colección",
    "lastModified": "Última modificación",
    "noCollectionAvailable": "No hay recogida disponible",
    "productAlreadyInCollection": "Producto ya está incluido en la colección",
    "sendEmail": "Compartir por correo electrónico",
    "shareCollection": "Compartir la colección \"{0}\" por email",
    "subject": "Asunto",
    "success": {
      "itemRemoved": "Producto retirado con éxito"
    }
  },
  "common": {
    "archive": "Archivo",
    "archived": "Archivado",
    "comment": "Cómo",
    "commentPlaceholder": "Añadir comentario aquí...",
    "comments": "Comentarios",
    "dearchive": "Buscador",
    "error": {
      "changeQuantity": "No se ha podido modificar la cantidad",
      "removeItem": "No se ha podido eliminar el elemento",
      "updateAssignee": "No se ha podido cambiar el empleado responsable",
      "updateComment": "No se ha podido actualizar el comentario",
      "updateName": "No se ha podido actualizar el título de la colección"
    },
    "sellerComment": "Comentario para el vendedor"
  },
  "company": {
    "deleteEmployee": "Eliminar empleado",
    "employee": "Empleado",
    "employeeDeleted": "El empleado fue destituido",
    "employees": "Empleados"
  },
  "companyData": "Datos de la empresa",
  "companyRegistration": "Aún no existe una empresa para la dirección de correo electrónico facilitada. Rellene el siguiente formulario para solicitar acceso.",
  "condition": {
    "B_STOCK": "Stock B",
    "BUILD_TO_ORDER": "Fabricación a medida",
    "BULK": "A granel",
    "DEMONSTRATION_MODEL": "Modelo de demostración",
    "FACTORY_REFURBISHED": "Reacondicionado de fábrica",
    "NEW": "Nuevo",
    "NEWPULL": "Pieza de repuesto de un dispositivo nuevo",
    "NOT_FOR_RESALE": "No para reventa",
    "REFURBISHED": "Reacondicionado",
    "RMA_WARE": "RMA",
    "USED": "Usado",
    "USEDPULL": "Recambio de aparato usado"
  },
  "conditionTooltip": {
    "conditionLabel": "Estado",
    "monthsWarranty": "meses de garantia"
  },
  "contactData": {
    "contactData": "datos de contacto",
    "email": "Correo electrónico",
    "firstName": "Nombre",
    "lastName": "Apellido"
  },
  "contactTitles": {
    "diverse": "Mx.",
    "female": "Sra.",
    "male": "Sr.",
    "unspecified": "sin especificar"
  },
  "continue": "Continúe en",
  "copy": "Copia",
  "coreData": "Datos básicos",
  "costs": "Costes",
  "create": "Cree",
  "created": "Creado",
  "createdDate": "Fecha de creación",
  "cto": {
    "appleCtoFinder": "Buscador de CTO de Apple",
    "configure": "Configurar {0}",
    "customiseConfiguration": "Personalizar la configuración",
    "foundProduct": "Producto encontrado",
    "noProductFound": "No se ha encontrado ningún producto para esta configuración",
    "selectBaseModel": "Seleccione el modelo base",
    "selectedConfiguration": "Configuración seleccionada",
    "selectProductClass": "Seleccione la clase de producto Apple"
  },
  "customerOrderId": "Número de pedido del cliente",
  "datasheet": "Ficha de datos",
  "datasheetError": "No se ha podido cargar la hoja de datos",
  "datasheetManufacturer": "Ficha del fabricante",
  "datasheetNotFound": "No hay hoja de datos disponible para este producto",
  "datasheetPdf": "Hoja de datos (PDF)",
  "decline": "Declive",
  "declineReason": "Motivo de la baja",
  "delete": "Borrar",
  "deleteAddress": "Borrar dirección",
  "deleteAddressDialog": "¿Está seguro de que desea eliminar esta dirección?",
  "deleteContactData": "Borrar datos de contacto",
  "deliveryTracking": {
    "deliveryTracking": "Información de envío",
    "trackPackage": "Paquete de vías"
  },
  "departments": {
    "Accounting": "Contabilidad",
    "Extern": "Externa",
    "IT": "TI",
    "Management": "Gestión",
    "Marketing": "Marketing",
    "Other": "Otros",
    "Purchasing": "Compras",
    "RegistrationPending": "Registro pendiente",
    "Sales": "Sales",
    "ServiceSupport": "Servicio/Apoyo"
  },
  "discount": "- {0} de descuento",
  "documentError": "No se ha cargado el documento",
  "downloadAllOrderDocumentsAsPdf": "Descargar todos los documentos de pedido en PDF",
  "downloadOrderDocumentAsPdf": "Descargar documento de pedido «{0}» en formato PDF",
  "ean": "EAN",
  "editAddress": "Editar dirección",
  "editCollectionAssignee": "Cambiar empleado responsable",
  "editContactData": "Editar datos de contacto",
  "ellipsis": "...",
  "emailAddress": "Dirección de correo electrónico",
  "emailForRegistration": "Ingrese una dirección de correo electrónico con la que desea registrarse.",
  "emailRequestPriceHint": "Se enviará el siguiente correo al propietario de la tienda (esto es sólo una vista previa del texto):",
  "emptyCart": "No hay ningún producto en la cesta de la compra",
  "epeat": "Certificado EPEAT",
  "epeatTooltip": {
    "description1": "Etiqueta ecológica internacional para productos informáticos.",
    "description2": "Evalúa la eficiencia energética, la reciclabilidad y la elección de materiales, entre otras cosas.",
    "description3": "Niveles: Bronce, Plata, Oro: cuanto más alto, más respetuoso con el medio ambiente.",
    "title": "Etiqueta EPEAT"
  },
  "eprel": {
    "energyEfficiency": "Etiqueta energética",
    "energyEfficiencyAndProductDatasheet": "Información sobre la etiqueta energética",
    "energyEfficiencyInformationSheet": "Ficha técnica"
  },
  "error": {
    "addressCreated": "No se ha podido crear la dirección",
    "addressDeleted": "No se ha podido eliminar la dirección",
    "addressesNotFound": "No se pueden cargar las direcciones",
    "addressPropertyInvalid": "El campo de dirección {propertyName} no es válido.",
    "addressSaved": "No se ha podido guardar la dirección",
    "alreadyInvited": "El colega {0} ya está invitado",
    "alreadyRegistered": "El colega {0} ya está registrado",
    "cartNotFound": "No se ha podido cargar el carro",
    "categoriesNotFound": "No se pueden cargar las categorías",
    "changePassword": "Algo ha ido mal al intentar cambiar la contraseña",
    "changeQuantity": "No se ha podido modificar la cantidad del carrito",
    "collectionNotFound": "No se ha podido cargar la colección",
    "documentsNotFound": "No se pueden cargar los documentos",
    "emailAlreadyRegistered": "El correo electrónico ya está registrado.",
    "emptyField": "El campo {0} debe tener un valor válido",
    "essentialShopActivationRequested": "Ha ocurrido un error al enviar la solicitud",
    "fileTooLarge": "El tamaño del archivo es demasiado grande",
    "genericError": "Algo salió mal",
    "identifiersNotFound": "No se han podido cargar los identificadores",
    "invalidCharacters": "Solo se permiten letras, números y los caracteres _ / . # +, así como paréntesis y corchetes (mínimo de 3 caracteres)",
    "invalidEmail": "Dirección de correo electrónico no válida",
    "invalidEmails": "Las siguientes direcciones de correo no son válidas: {0}",
    "invalidName": "Nombre no válido",
    "invalidNegativeNumber": "Sólo se admiten números positivos",
    "invalidNumber": "Número no válido",
    "invalidUrl": "URL no válida",
    "invalidWhitespace": "No se permiten espacios iniciales, finales o múltiples consecutivos",
    "invitation": "Algo ha ido mal al intentar enviar la invitación",
    "keywordTooShort": "Introduzca un término de búsqueda de al menos 2 caracteres",
    "mailBlacklisted": "El dominio {0} no está en la lista blanca. Póngase en contacto con el administrador del portal..",
    "noAdmin": "Necesitas derechos de administrador para invitar a colegas",
    "noConsent": "El consentimiento debe firmarse",
    "oldPassword": "Contraseña actual no es válida",
    "ordersNotFound": "No se pueden cargar los pedidos",
    "pageNotFound": "Página no encontrada",
    "passwordNotAllowedChar": "La contraseña contiene uno o más caracteres prohibidos.",
    "passwordRepeat": "Los valores de los campos de contraseña no coinciden",
    "passwordRequirements": "Su contraseña no cumple los requisitos de contraseña actuales.",
    "positiveDigit": "El valor tiene que ser positivo",
    "productAdded": "No se ha podido añadir el producto a la cesta",
    "productAlreadyInComparison": "Producto ya está incluido en la comparación",
    "productComparisonMaxNumber": "Se puede comparar un máximo de 3 productos",
    "productDeleted": "No se ha podido retirar el producto de la cesta",
    "productNotAvailableBySupplier": "Este proveedor no ofrece el producto.",
    "productNotFound": "No se ha podido cargar el producto",
    "productRequest": "Algo ha ido mal al intentar enviar la solicitud",
    "productTypeIncorrectForComparison": "Sólo los productos de la misma categoría pueden compararse entre sí",
    "quoteForbidden": "Esta oferta aún no está activa",
    "quoteNotFound": "No se puede cargar la oferta",
    "quotesNotFound": "No se pueden cargar las ofertas",
    "refresh": "Otros usuarios han realizado cambios. Actualiza la página.",
    "registration": "Algo ha ido mal al intentar enviar el registro",
    "registrationTokenError": "El enlace para registrar un nuevo usuario parece estar defectuoso. Por favor, solicite uno nuevo.",
    "requiredField": "Campo obligatorio",
    "resetPassword": "Algo ha ido mal al intentar restablecer la contraseña",
    "resetTokenError": "El enlace para restablecer la contraseña ya no es válido. Por favor, solicite una nueva.",
    "serverError": "Error del servidor",
    "shortPassword": "Debe tener al menos 8 caracteres",
    "startPage": "No se ha podido cargar la página de inicio",
    "timeout": "La solicitud ha caducado",
    "tooManyRequests": "Demasiadas consultas. Pruébalo de nuevo más tarde.",
    "unknownError": "Se ha producido un error desconocido durante la solicitud ({0}).",
    "unknownLoginError": "Se ha producido un error desconocido al iniciar sesión.",
    "unsupportedMediaType": "El tipo de archivo no es compatible",
    "updateComment": "No se ha podido actualizar el comentario de texto libre",
    "userDeactivated": "El usuario especificado está desactivado, actualmente no es posible iniciar sesión.",
    "validDigit": "El valor debe ser un número entero válido",
    "wrongCredentials": "Tu dirección de correo electrónico o contraseña son incorrectas."
  },
  "errorId": "ID de error",
  "errorPageHeadline": "Algo salió mal.",
  "errorPageOops": "Ooops",
  "errorPageQuoteNotAvailableSorry": "Vuelva a intentarlo más tarde.",
  "errorPageStart": "Ir a la página de inicio",
  "essentialShopDeactivated": {
    "descriptionEnd": "Hable con su socio para obtener acceso",
    "descriptionPoint1": "Ver el historial de sus ofertas",
    "descriptionPoint2": "Enviar solicitudes de ofertas directamente a su socio",
    "descriptionPoint3": "Acceder a una gama de 50 000 productos informáticos con filtro y búsqueda",
    "descriptionPoint4": "Realizar pedidos de forma sencilla y directa",
    "descriptionStart": "En la tienda Essential tiene la posibilidad de:",
    "descriptionTitle": "La tienda Essential de su socio está desactivada actualmente",
    "pageTitle": "Essential Shop desactivado",
    "requestActivation": "Solicitar activación",
    "requestActivationHint": "Introduzca su dirección de correo electrónico para que su socio pueda ponerse en contacto con usted."
  },
  "excludingVatHint": "Todos los precios excl.{0} IVA",
  "excludingVatShort": "excl.{0} IVA",
  "expandAccessoryCategory": "Ampliar la categoría de accesorios «{0}»",
  "expandDescription": "Expandir descripción «{0}»",
  "featureAd": {
    "comparison": {
      "description": "Puede añadir productos para su comparación a través de la página de productos",
      "shortDescription": "Ahora puede comparar productos.",
      "title": "Comparación de productos"
    },
    "descriptionEnd": "Se nos notificará y le presentaremos un presupuesto directamente en su portal.",
    "descriptionStart": "Así se solicita una colección de productos:",
    "NEW": "NUEVO",
    "requestFunction": "Envío de solicitudes de presupuesto",
    "step1": "Haga clic en \"Crear solicitud\"",
    "step2": "Añadir productos",
    "step3": "Enviar la solicitud",
    "tryItOut": "Pruébelo"
  },
  "filter": {
    "filter": "Filtro",
    "filters": "Filtros",
    "noFiltersSelected": "No hay filtros seleccionados",
    "productFilters": "Características",
    "productType": "Tipo de producto",
    "resetFilter": "Restablecer filtro"
  },
  "finishRegistration": "Finalizar el registro",
  "forgotPassword": "¿Ha olvidado su contraseña?",
  "grading": {
    "A": "Como nuevo",
    "B": "Muy bueno",
    "C": "Bueno",
    "D": "Aceptable"
  },
  "hideCategories": "Ocultar categorías",
  "hideCategory": "Doblar la categoría",
  "hidePassword": "Ocultar la contraseña",
  "impersonateMode": "Vista del cliente - Ha iniciado sesión como administrador de la tienda B2B en {0}",
  "impersonateModeEssentialShop": "Vista del cliente - Registrado como operador de la tienda",
  "includingVat": "incl.{0} IVA",
  "includingVatHint": "Todos los precios incluyen{0} IVA",
  "includingVatShort": "incl.{0} IVA",
  "invitationHint": "Aquí puede invitar a otros colegas a su portal. Introduzca las direcciones de correo electrónico a las que desea enviar una invitación y sepárelas con punto y coma o espacio.",
  "inviteColleagues": "Invite a sus colegas",
  "languages": {
    "de": "Alemán",
    "en": "Inglés",
    "es": "Español",
    "fr": "Francés",
    "it": "Italiano",
    "nl": "Holandés",
    "pl": "Polaco"
  },
  "legalInfo": "Información legal",
  "less": "menos",
  "localization": "Localización",
  "login": "Inicio de sesión",
  "login_sso": "Inicio de sesión con inicio de sesión único (SSO)",
  "loginQuotesPortal": "Iniciar sesión en el portal de ofertas",
  "manufacturerId": "Identificación del fabricante",
  "max": "Máx.",
  "maxLength": "Se ha alcanzado la longitud máxima de caracteres de {0}.",
  "mobex360Info": "Si el crédito de mobex360 es insuficiente, ¡el pedido se facturará automáticamente!",
  "mobexPaymentMethod": {
    "CREDIT": "Con crédito mobex360",
    "INVOICE": "Por factura"
  },
  "more": "más",
  "moreInfoEpeatTooltip": "Más información sobre la etiqueta EPEAT",
  "moreUppercase": "Más",
  "myCompany": "Mi empresa",
  "myProfile": "Mi perfil",
  "name": "Nombre",
  "newPassword": "Nueva contraseña",
  "newPasswordRepeat": "Confirmar nueva contraseña",
  "no": "No",
  "noAppleProductsAvailable": "No hay productos Apple disponibles",
  "noCategoriesFound": "No hay categorías disponibles",
  "noCollectionsFound": "No hay colecciones disponibles",
  "noDataAvailable": "No hay datos disponibles",
  "noEntries": "No hay entradas disponibles",
  "noImageAvailable": "No hay imagen disponible",
  "noItemsInQuote": "Esta oferta no contiene ningún producto",
  "noOrderDocumentsFound": "No hay documentos disponibles",
  "noOrdersFound": "No hay pedidos disponibles",
  "noProductsFound": "No se han encontrado productos",
  "noSupplier": "Sin asignar",
  "nullPriceLabel": "-.--",
  "oldPassword": "Contraseña actual",
  "onlyWholePositiveNumbers": "Sólo se admiten números enteros positivos",
  "open": "Abrir",
  "openCart": "Abra el carrito de compras",
  "openCategory": "Doblar la categoría",
  "openFilter": "Abra el filtro",
  "openMenu": "Menú abierto",
  "openProductComparison": "Abra la comparación del producto",
  "openProductPage": "Abrir la página del producto",
  "openTopiCheckout": "Abrir la caja topi",
  "optimizationStrategyType": {
    "MANUAL": "Manualmente",
    "MINPRICE": "Mejor precio",
    "MINSUPPLIERS": "Fuentes mínimas"
  },
  "order": {
    "addedToCartFailure": "No se ha podido añadir el pedido a la cesta de la compra",
    "addedToCartPartialSuccess": "No se han podido añadir algunos artículos a la cesta de la compra",
    "addedToCartSuccess": "Pedido añadido a la cesta",
    "customerOrderIdMissing": "Debe indicarse un identificador de pedido de cliente.",
    "declineOrder": "Orden de rechazo",
    "deleteDialog": "¿Está seguro de que desea eliminar este pedido?",
    "deleteLastItemDialog": "Atención: Al borrar la última posición del pedido, se borrará también el pedido completo. ¿Desea continuar?",
    "deleteOrder": "Borrar orden",
    "deleteOrderItem": "Borrar posición de pedido",
    "details": "Pida",
    "documents": "Documentos",
    "editAddressHint": "Los cambios de dirección sólo afectan a este pedido.",
    "exclTotalTax": "excl.{0} IVA {1}",
    "goToOrder": "Continuar con el pedido",
    "inclTotalTax": "incl.{0} IVA {1}",
    "inEuTotalTax": "más{0} IVA {1}",
    "moreInfosLabel": "Para más información",
    "netDiscount": "Descuento adicional",
    "noApprover": "Parece que no hay aprobador elegible para este pedido. Póngase en contacto con el operador de su portal.",
    "noOrderRightHint": "No tiene permiso para ejecutar la orden.",
    "order": "Pida",
    "orderAlreadyBeingProcessed": "El pedido ya está siendo procesado. Por favor, espere unos minutos.",
    "orderDate": "Fecha del pedido",
    "orderLimitApprovalHint": "Las siguientes personas serán notificadas por correo electrónico sobre su solicitud de aprobación de pedido. En cuanto se confirme o rechace la aprobación del pedido, se le informará por correo electrónico.",
    "orderLimitHint": "El pedido por valor de {0} ha superado su límite de pedido actual de {1}. Por favor, solicite la aprobación de la orden.",
    "orderNotFound": "No se ha podido cargar el pedido",
    "orderNumber": "Número de pedido",
    "orderNumberDuplicate": "El número de pedido {0} ya está en uso. Utilice un número de pedido diferente.",
    "orderNumberGeneratedAfterOrder": "Se genera después de la orden",
    "orderNumberMissing": "Debe indicarse un número de pedido.",
    "orderNumbers": "Números de pedido",
    "orderRequested": "Solicitud enviada",
    "orders": "Pedidos",
    "orderSent": "Su pedido ha sido enviado y está siendo procesado.",
    "orderTimeoutError": "No se recibió respuesta del pedido. Por favor, recargue la página.",
    "partialShipmentAllowed": "Envío parcial permitido",
    "paymentMethodMissing": "Debe indicarse un método de facturación.",
    "quantitySurcharge": "Recargo por pedido mínimo",
    "requestOrder": "Solicitar",
    "selectAddressHint": "Sólo se pueden utilizar las direcciones creadas por usted.",
    "sendOrder": "Pedido vinculante",
    "shippingAddress": "Dirección de envío",
    "shippingCosts": "Envío",
    "shippingCostsGross": "Gastos de envío brutos",
    "shippingCostsNet": "Gastos de envío netos",
    "subTotal": "Subtotal",
    "toOrder": "Realizar pedido",
    "toOrderFrom": "Ordenar desde {0}",
    "totalCostsGross": "Importe bruto total",
    "totalCostsNet": "Importe total neto"
  },
  "orderApproval": {
    "approvableOrders": "Pedidos sin aprobación",
    "approvedInformation": "El pedido fue aprobado por {0} el {1}.",
    "declinedInformation": "El pedido fue rechazado por {0} el {1}.",
    "orderDeclined": "Pedido rechazado con éxito",
    "pendingInformation": "{1} solicitó la aprobación de esta orden el {0} de las siguientes personas:",
    "pendingInformationApprover": "Se le ha enviado una aprobación de pedido el {0}.",
    "pendingInformationRequester": "Ha enviado una aprobación de pedido el {0} a la siguiente persona:"
  },
  "orderBy": "Pedido realizado a {0}",
  "ordered": "Encargado",
  "orderLimits": {
    "activateOrderLimits": "Activar límites de órdenes",
    "default": "Por defecto",
    "defaultApprovers": "Aprobador por defecto",
    "defaultApproversEmpty": "No se ha seleccionado ningún autorizador por defecto",
    "defaultApproversUsed": "Se utilizan aprobadores por defecto",
    "defaultLimit": "Límite general",
    "defaultLimitDescription": "Este límite de pedido es el valor por defecto para todos los empleados y es sobrescrito por límites de pedido específicos para empleados.",
    "description": "Al asignar límites, los empleados sólo pueden hacer pedidos hasta un valor determinado. Los pedidos que superen este valor deben solicitarse a un compañero con derechos de aprobación.",
    "editOrderLimitUser": "Modificar límite de pedido del usuario «{0}»",
    "editStandardApprovers": "Editar aprobadores por defecto",
    "individual": "Individual",
    "noEmployeeFound": "No se ha encontrado ningún empleado",
    "noEmployeesFound": "No hay empleados disponibles",
    "orderApproval": "Aprobación del pedido",
    "orderApprover": "Aprobador de pedidos",
    "orderLimit": "Límite de pedido",
    "orderRight": "Ordenar bien",
    "unlimited": "Sin límites"
  },
  "orderOutdated": {
    "description": "No se puede enviar el pedido porque está caducado. Por favor, vuelva a cargar el pedido y ejecútelo de nuevo.",
    "title": "Pedido caducado"
  },
  "orderStatus": {
    "ADVISED": "Enviado",
    "ARRIVED": "Pedido recibido",
    "ARRIVED_WARNING": "Recibido con advertencia",
    "BLOCKED": "Bloqueado",
    "BLOCKED_BYLIMIT": "Bloqueado",
    "CANCELED": "Cancelado",
    "ERROR": "Error",
    "IN_TOPI_CHECKOUT": "En la caja topi",
    "INVOICED": "Facturado",
    "ORDERED_ELSEWHERE": "Pedidos en otros lugares",
    "PARTIALLY_ADVISED": "Enviado parcialmente",
    "PARTIALLY_INVOICED": "Parcialmente facturado",
    "PARTIALLY_PROCESSING": "Confirmado parcialmente",
    "PAYMENT_AWAITING": "En espera de pago",
    "PAYMENT_SUCCESSFUL": "Pago efectuado",
    "PENDING_TOPI_APPROVAL": "Pendiente de autorización",
    "PORTAL_APPROVAL_DENIED": "Rechazado",
    "PREPARING": "Pendiente",
    "PROCESSING": "Pedido confirmado",
    "REJECTED": "Rechazado",
    "SENDING_ERROR": "Error de transmisión",
    "SENT": "Transmitido",
    "TOPI_DECLINED": "Rechazado por topi",
    "TOPI_EXPIRED": "Oferta topi caducada",
    "TRANSMITTING": "Transmitiendo"
  },
  "partsList": "Lista de piezas",
  "password": "Contraseña",
  "passwordRepeat": "Repetir contraseña",
  "paymentMethod": "Forma de pago",
  "PDF": "PDF",
  "per": "por",
  "personalData": "Datos personales",
  "pleaseSelect": "Por favor, seleccione...",
  "portal": "Portal",
  "portalPaused": "Portal en pausa",
  "portalPausedDescription": "Este portal está actualmente en pausa, por lo que no es posible iniciar sesión. Si tiene alguna pregunta, póngase en contacto con el propietario del portal.",
  "positions": "Ninguna posición | {n} posición | {n} posiciones",
  "price": {
    "graduatedPrices": "Precios escalonados",
    "manufacturerSuggestedRetailPrice": "MSRP",
    "packaging": "Unidad de embalaje",
    "packaging_contentUnit": "Unidad de contenido:",
    "packaging_contentUnit_label": "Unidad del artículo dentro de una unidad de pedido (por ejemplo, \"pieza\" en la unidad de pedido \"paquete\").",
    "packaging_intervalQuantity": "Intervalo de cantidades:",
    "packaging_intervalQuantity_label": "Cantidad que indica el intervalo en el que se puede pedir el artículo (en unidades de pedido).",
    "packaging_minQuantity": "Cantidad mínima de pedido:",
    "packaging_minQuantity_label": "La cantidad mínima de existencias que debe pedirse.",
    "packaging_numberContentUnitPerOrderUnit": " Cantidad de envases:",
    "packaging_numberContentUnitPerOrderUnit_label": "Número de subunidades que contiene la unidad del artículo.",
    "packaging_orderUnit": "Unidad de pedido:",
    "packaging_orderUnit_label": "Unidad en la que puede pedirse el producto; sólo pueden pedirse múltiplos de la unidad del artículo.",
    "packaging_priceQuantity": "Precio por cantidad:",
    "packaging_priceQuantity_label": "Múltiplo de la unidad de pedido, que indica la cantidad a la que se refieren los precios.",
    "packaging_supplierPackingQuantity": "Cantidad de envases del proveedor:",
    "packaging_supplierPackingQuantity_label": " Cantidad de envases del proveedor (en unidades de pedido).",
    "price": "Precio",
    "priceBillingPeriod": "por {0}",
    "priceBillingPeriodShort": "p. {0}",
    "priceOnRequest": "O/R",
    "pricePurchase": "WSP",
    "priceSubscriptionPeriod": "{0} período del contrato",
    "priceVatStar": "*",
    "startingAt": "empezando en {0}"
  },
  "priceRange": {
    "applyPriceRange": "Aplicar rango de precios",
    "fromPriceRange": "De {0} {1}",
    "fromToPriceRange": "{0} {2} - {1} {2}",
    "invalidPriceRange": "Rango de precios no válido",
    "priceRange": "Precios",
    "priceRangeFrom": "Gama de precios",
    "priceRangeTo": "Rango de precios",
    "toPriceRange": "Hasta {0} {1}"
  },
  "print": "Imprimir",
  "privacy": "Privacidad",
  "privacyConsent": "Acepto que mis datos sean tratados de acuerdo con la política de privacidad.",
  "product": "Producto",
  "productAccessories": "Accesorios",
  "productComparison": {
    "highlightDifferences": "Destacar las diferencias",
    "noData": "No se han encontrado datos comparables para los productos seleccionados",
    "noMobileVersion": "La comparación de productos no está disponible en la vista móvil",
    "noProducts": "Ningún producto en comparación",
    "pageTitle": "Comparar productos",
    "removeProduct": "Retirar producto de la comparación"
  },
  "productDescription": "Descripción",
  "productId": "Identificación del producto",
  "productIdentifiers": "Identificación de productos",
  "productNoLongerAvailable": "Producto no disponible",
  "products": "Productos",
  "productSort": {
    "AVAILABILITY": "Disponibilidad",
    "CALC_PRICE_ASC": "Precio ascendente",
    "CALC_PRICE_DESC": "Precio descendente",
    "NAME_ASC": "Nombre del producto ascendente",
    "NAME_DESC": "Nombre del producto descendente",
    "POPULARITY": "Popularidad",
    "RELEVANCE": "Relevancia",
    "STOCK": "Nivel de existencias"
  },
  "productStockInfo": {
    "nextDelivery": "Próxima fecha de entrega según distribuidor prevista el {0}.",
    "nextDeliveryB2B": "Fecha prevista de entrega al proveedor anterior: {0}.",
    "noNextDelivery": "Se desconoce la fecha exacta de entrega.",
    "onStock": "{0} en stock",
    "onSupply": "{0} pronto disponible",
    "unavailableMessage": "Este producto no está disponible."
  },
  "punchout": {
    "backToProcurement": "Volver a su sistema",
    "backToProcurementCaption": "Sin orden de vuelta a su sistema | Tome una posición en su sistema | {n} posiciones de vuelta a su sistema",
    "table": {
      "position": "ID",
      "price": "Precio",
      "quantity": "Cantidad",
      "sum": "Suma",
      "title": "Título"
    }
  },
  "quantityFrom": "Cantidad a partir de",
  "quoteOutdated": {
    "description": "No se puede enviar el pedido porque la oferta está caducada. Por favor, vuelva a cargar la oferta y ejecútela de nuevo.",
    "title": "Oferta caducada"
  },
  "quotePreview": "Ésta es la vista previa de la oferta",
  "quoteRegistration": {
    "description": "Al registrarse en su Essential shop personal, obtendrá...",
    "products": "Acceso a <b>50 000 productos informáticos</b>",
    "quoteDocument": "acceso a todos los <b>documentos de oferta</b> relevantes",
    "quoteHistory": "el <b>historial de ofertas</b> con todas las ofertas recibidas anteriormente",
    "quoteRequest": "la opción de enviar <b>solicitudes</b>"
  },
  "quoteRequest": {
    "cannotEditRequest": "No hay más cambios posibles, la solicitud ya ha sido enviada.",
    "emptyRequest": "Aún no se han añadido productos",
    "lineItemAdded": "El artículo se ha añadido correctamente",
    "notInAssortment": "Actualmente no en el surtido",
    "requestAgain": "Solicitar otra vez",
    "requestNotFound": "No se ha encontrado la solicitud de presupuesto",
    "sendRequest": "Enviar solicitud",
    "sentQuoteRequest": "Solicitud de oferta enviada",
    "textLineItemAdd": "Añadir elemento de texto",
    "textLineItemChangeError": "No se ha podido modificar el título de la posición del texto"
  },
  "quotes": {
    "acceptQuote": "Aceptar oferta",
    "addProductToExistingQuote": "Añadir producto a consulta existente:",
    "addProductToNewQuote": "o crear una nueva consulta:",
    "author": "Autor",
    "createRequest": "Crear solicitud",
    "declineInformation": "La oferta fue rechazada por {0} el {1}.",
    "declineQuote": "Rechazar oferta",
    "declineQuoteDialog": "¿Seguro que quiere rechazar esta oferta?",
    "deleteDescription": "¿Está seguro de que desea que se elimine esta solicitud?",
    "deleteTitle": "Borrar solicitud",
    "deselectOptionalItem": "Deseleccionar posición opcional",
    "duplicateUserWarning": "No puede aceptar esta oferta porque su dirección de correo electrónico ya está vinculada a otra empresa. Póngase en contacto con el creador de la oferta.",
    "editTitle": "Cambiar el título de la solicitud",
    "new": "Nuevo",
    "noLongerValid": "Esta oferta expiró el \"{0}\" y ya no es válida.",
    "noOptionalPosition": "Sin posición opcional",
    "noQuoteEmptySpace": "Aún no hay oferta disponible",
    "noQuoteRequestsFound": "No hay solicitudes disponibles",
    "noQuotesFound": "No hay ofertas  disponibles",
    "quote": "Oferta",
    "quoteRequested": "La solicitud se ha creado correctamente",
    "quotes": "Ofertas",
    "request": "Solicitar",
    "selectOptionalItem": "Seleccionar posición opcional",
    "showActivity": "Mostrar actividades"
  },
  "quoteStatus": {
    "ACCEPTED": "Aceptado",
    "DRAFT": "Borrador",
    "NEGOTIATION": "En curso",
    "REJECTED": "Rechazado",
    "REQUESTED": "Solicitado"
  },
  "readOnlyMode": "Actualmente se encuentra en modo de sólo lectura.",
  "realtimePrices": "Precios en tiempo real",
  "realtimePricesLoaded": "Precios en tiempo real cargados",
  "recipients": "Recipients",
  "refresh": "Actualizar",
  "refreshPage": "Recargar página",
  "register": "Regístrese en",
  "registerCompany": "Registrar empresa",
  "registration": "Inscripción",
  "registrationDisabled": "Registro desactivado",
  "registrationDisabledDescription": "El operador ha desactivado el registro y la conexión a este portal.",
  "registrationLinkSent": "Se ha enviado a su dirección de correo electrónico un mensaje con el enlace de registro. Por favor, abra el enlace para completar el registro.",
  "registrationRequested": "La solicitud ha sido transmitida al operador del portal. Recibirá una notificación cuando la solicitud haya sido aceptada.",
  "removeDialog": "¿Está seguro de que desea eliminar a este empleado?",
  "removeProductFromCart": "Eliminar el producto del carrito de compras",
  "removeProductFromCollection": "Eliminar el producto de la recolección",
  "removeProductFromQuoteRequest": "Eliminar el producto de la solicitud",
  "requestPrice": "Solicitar precio",
  "requestRegistration": "Solicitar acceso",
  "resetPassword": "Restablecer contraseña",
  "rma": {
    "requested": "Solicitud de devolución enviada",
    "return": "Devolución",
    "returned": "devuelto",
    "returnReason": "Motivo de la devolución",
    "selectedPositions": "Puestos seleccionados",
    "selectPositions": "Seleccione los artículos que desea devolver",
    "selectProductForReturn": "Seleccionar producto para devolución",
    "selectReturnReason": "Seleccione el motivo"
  },
  "save": "Guardar",
  "saveAddress": "Guardar dirección",
  "search": "Buscar en",
  "searchAll": "Buscar todos",
  "searchResults": "Buscar \"{0}\" en los productos",
  "send": "Enviar",
  "sendInvitation": "Enviar invitación",
  "serialNumbers": {
    "copyAll": "Copiar todo",
    "serialNumbers": "Números de serie",
    "serialNumbersCopied": "Números de serie copiados en el portapapeles"
  },
  "serverOffline": {
    "description": "El portal no está disponible debido a tareas de mantenimiento. Vuelva a intentarlo más tarde.",
    "title": "Portal no disponible"
  },
  "shippingCostsShort": "Envío",
  "shoppingCart": "Cesta de la compra",
  "shortUrl": {
    "enterZipCode": "Para abrir la oferta, introduzca el código postal de su dirección:",
    "enterZipCodeTitle": "Introduzca el código postal",
    "error": "¡Uy! ¡Este enlace no es válido!",
    "wrongZipCode": "El código postal introducido no es válido."
  },
  "showCategories": "Mostrar categorías",
  "showErrorOrders": "Mostrar todos los pedidos con estado de error",
  "showPassword": "Mostrar contraseña",
  "signIn": "Inicio de sesión",
  "signOut": "Cerrar sesión",
  "sortBy": "Ordenar por",
  "sortbyAsc": "Ordenar en orden ascendente por «{0}»",
  "sortByDesc": "Ordenar en orden descendente por «{0}»",
  "sources": "Fuentes de suministro",
  "status": "Estado",
  "stock": "Stock",
  "stockStatus": {
    "Available": "Disponible",
    "NotAvailable": "No disponible",
    "OnOrder": "Por pedido",
    "OnStock": "En stock",
    "Ordered": "Pronto disponible",
    "Unknown": "Desconocido",
    "Warehouse": "stock externo"
  },
  "stockStatusDescription": "El estado de las existencias es «{0}»",
  "subsidiaryMode": "Vista del cliente - Ha iniciado sesión en {0}",
  "success": {
    "addedToCollection": "Producto añadido correctamente a la colección",
    "addedToCollectionLink": "Producto añadido correctamente a la colección \"{0}\" >>",
    "addedToComparison": "Producto añadido para comparación",
    "addedToQuote": "El producto se ha añadido correctamente a la consulta",
    "addedToQuoteLink": "El producto se ha añadido correctamente a la consulta. >>",
    "addressCreated": "Se creó la dirección",
    "addressDeleted": "Dirección eliminada",
    "addressSaved": "Dirección guardada",
    "cartRefreshed": "Cesta de la compra actualizada",
    "changeLanguage": "Cambio de idioma",
    "changePassword": "Contraseña modificada correctamente",
    "essentialShopActivationRequested": "Se ha enviado la solicitud de activación",
    "invitationSent": "Invitación enviada correctamente",
    "orderArchived": "Pedido archivado",
    "orderDearchived": "Pedido desarchivado",
    "productAdded": "Producto añadido a la cesta",
    "productDeleted": "Se ha eliminado el producto de la cesta",
    "productRequested": "Solicitud de producto enviada",
    "quoteArchived": "Oferta archivada",
    "quoteDearchived": "Oferta des-archivada",
    "registrationComplete": "Registro efectuado con éxito",
    "removedFromComparison": "Se ha eliminado el producto de la comparación",
    "resetPassword": "Se ha enviado un correo electrónico a \"{0}\" si existe una cuenta de usuario activa."
  },
  "supplier": "Proveedor",
  "supplierPid": " Distribuidor n",
  "switchSubsidiary": "Cambiar de empresa",
  "switchSubsidiaryHint": "Puedes conectarte a otras empresas",
  "technicalData": "Datos técnicos",
  "terms": "GTC",
  "time": {
    "day": "día",
    "hour": "hora",
    "minute": "minuto",
    "month": "mes",
    "year": "año"
  },
  "title": "Título",
  "to": "a",
  "today": "Hoy",
  "topiExpiredHint": "Lamentablemente, la oferta en topi ha caducado. Vuelva a añadir los productos a su cesta de la compra mediante el menú de tres puntos y, a continuación, haga clic en «Continue to rental configuration».",
  "transactionType": {
    "DELIVERY": "Albarán de entrega",
    "INVOICE": "Factura proforma",
    "ORDER": "Pida",
    "ORDERSTATUS": "Respuesta al pedido",
    "PAYMENT": "Pago"
  },
  "unknown": "desconocido",
  "updated": "Actualizado",
  "user": {
    "avatar": "Avatar",
    "company": "Empresa",
    "contactTitle": "Título del contacto",
    "department": "Departamento",
    "email": "Correo electrónico",
    "firstName": "Nombre",
    "language": "Idioma",
    "lastName": "Apellido",
    "permissions": {
      "changeSubsidiary": "Cambiar de empresa",
      "changeSubsidiaryDescription": "Determina si el usuario puede iniciar sesión en empresas relacionadas.",
      "permissions": "Permisos de usuario",
      "shopAdmin": "Admin",
      "shopAdminDescription": "Como administrador, el usuario está autorizado a editar los derechos, datos de contacto, límites de pedidos y aprobaciones de otros empleados. Además, el usuario administrador puede invitar a nuevos compañeros directamente al portal.",
      "submitOrder": "Realizar pedidos",
      "submitOrderDescription": "Determina si el usuario está autorizado a realizar pedidos."
    },
    "phone": "Número de teléfono",
    "phoneMobile": "Número de teléfono móvil",
    "settings": {
      "allowTracking": "Mejorar la experiencia del usuario",
      "allowTrackingDescription": "Participe en el programa de optimización para mejorar la experiencia del usuario.",
      "settings": "Configuración del usuario"
    }
  },
  "validDate": "Válido hasta el",
  "viewToggle": {
    "ordersApprovals": "Cambie la descripción general de la orden a \"Pedidos sin aprobación\"",
    "ordersGrid": "Cambie la descripción general del pedido a la vista de la columna",
    "ordersList": "Cambie la descripción general del pedido a la vista de la lista",
    "productsCards": "Cambie la descripción general del producto a la vista de mosaico",
    "productsList": "Cambie la descripción general del producto a la vista de la lista",
    "quoteActivityChat": "Cambiar la vista de actividad para chatear",
    "quoteActivityHistory": "Vista de actividades de cambio a la historia"
  },
  "windowTitle": {
    "Collection": "Colección",
    "CompanyOrderLimit": "Aprobación del pedido",
    "Login": "Página de acceso",
    "Registration": "Página de inscripción",
    "StartPage": "Página de inicio"
  },
  "writeSomething": "Escribe algo...",
  "yes": "Sí",
  "yesterday": "Ayer"
}
